"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CatalogueIPaperContainer = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _presentationHttp = require("@ori/presentation-http");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _components = require("../components");
var _constants = require("../constants");
var _constantsGenerated = require("../constants-generated");
var _contexts = require("../contexts");
var _logger2 = require("../logger");
var _utils = require("../utils");
var _ApiProvider = require("./ApiProvider");
var _jsxRuntime = require("react/jsx-runtime");
const CatalogueIPaperContainer = exports.CatalogueIPaperContainer = /*#__PURE__*/ (0, _react.memo)((param)=>{
    let { catalogueCode, config, isFlyer, language, mainTitle } = param;
    const initialPageNumber = (0, _utils.getPageNumber)();
    const { tenant } = (0, _environment.useEnvironment)();
    const { customerId, token } = (0, _auth.useToken)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
        team: _testidGenerator.Team.Presentation,
        project: _constantsGenerated.APP_NAME,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
            logger: _logger2.mainLogger,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
                areaName: "CatalogueIPaperContainer",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ApiProvider.ApiProvider, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
                        namespace: _constants.translationsNamespace,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationHttp.UserSegmentationDataProvider, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationHttp.HeadersProvider, {
                                customerId: customerId,
                                language: language,
                                sourceAppName: _constantsGenerated.PACKAGE_NAME,
                                tenant: tenant,
                                token: token,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_contexts.ConfigurationProvider, {
                                    catalogueCode: catalogueCode,
                                    config: config,
                                    isFlyer: isFlyer,
                                    mainTitle: mainTitle,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_contexts.PageNumberProvider, {
                                        initialPageNumber: initialPageNumber,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_contexts.OverviewProvider, {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.IPaper, {})
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
});
